import { Row, Form, Checkbox, Anchor } from "antd";
import { forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { update_runedbc_form } from "../../actions/form_slice";
import { debounce } from "lodash";
const { Link } = Anchor;

const RUNEDBC = forwardRef(({ onValuesChange }, ref) => {
  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    getFieldsError: form.getFieldsError,
    validateFields: form.validateFields,
    resetFields: form.resetFields,
    setFieldsValue: form.setFieldsValue,
    submit: form.submit,
    getFieldsValue: form.getFieldsValue,
  }));

  const dispatch = useDispatch();
  const formData = useSelector((state) => state.form.runedbc_form_type);

  const handleFormChange = debounce((changedValues) => {
    dispatch(update_runedbc_form(changedValues));
    onValuesChange(formData);
  }, 300);

  return (
    <Form
      form={form}
      onValuesChange={handleFormChange}
      // onFinish={props.onFinish}
      labelAlign="justify"
      layout="vertical"
      labelWrap
      wrapperCol={{
        flex: 1,
      }}
    >
      <Form.Item
        valuePropName="checked"
        name="Review all case details and ensure results are accurate.DO NOT accept incorrect EDBC results."
      >
        <Checkbox value="Review all case details and ensure results are accurate.DO NOT accept incorrect EDBC results.">
          Review all case details and ensure results are accurate.DO NOT accept
          incorrect EDBC results.
        </Checkbox>
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="Review the template, ensure all discrepancies are noted and the template is complete. (KEES WR Desk Aid)"
      >
        <Checkbox value="Review the template, ensure all discrepancies are noted and the template is complete. (KEES WR Desk Aid)">
          Review the template, ensure all discrepancies are noted and the
          template is complete. &nbsp;
          {
            <a
              href="http://dcfnet.dcf.ks.gov/EES/Documents/BPM/KEES Notice Cut and Paste.pdf"
              target="_blank"
              rel="noreferrer"
              style={{color: "Red", font: "1.2rem"}}
            >
              (KEES WR Desk Aid)
            </a>
          }
        </Checkbox>
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="Make sure all programs are authorized and processed through come up month."
      >
        <Checkbox value="Make sure all programs are authorized and processed through come up month.">
          Make sure all programs are authorized and processed through come up
          month.
        </Checkbox>
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="Ensure all Notices, Requests, and Forms are sent."
      >
        <Checkbox value="Ensure all Notices, Requests, and Forms are sent.">
          Ensure all Notices, Requests, and Forms are sent.
        </Checkbox>
      </Form.Item>
      <Form.Item valuePropName="checked" name="Update the task(s) in KEES.">
        <Checkbox value="Update the task(s) in KEES.">
          Update the task(s) in KEES.
        </Checkbox>
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="Update ALL E-apps with correct status."
      >
        <Checkbox value="Update ALL E-apps with correct status.">
          Update ALL E-apps with correct status.
        </Checkbox>
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="Only use Immediate Issuance for Food Assistance if the application is EXPEDITED and you’re processing benefits on the 7th day."
      >
        <Checkbox value="Only use Immediate Issuance for Food Assistance if the application is EXPEDITED and you’re processing benefits on the 7th day.">
          Only use Immediate Issuance for Food Assistance if the application is
          EXPEDITED and you’re processing benefits on the 7th day.
        </Checkbox>
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="Check that Review and IR / 12 Month Reporting page is correctly updated and EDBC run reason is correct."
      >
        <Checkbox value="Check that Review and IR / 12 Month Reporting page is correctly updated and EDBC run reason is correct.">
          Check that Review and IR / 12 Month Reporting page is correctly
          updated and EDBC run reason is correct.
        </Checkbox>
      </Form.Item>
      <Row style={{ marginTop: "10px", fontWeight: "bold" }}>
        Authorized Benefits
      </Row>
      <Row style={{ marginTop: "10px" }}>
        <Form.Item
          valuePropName="checked"
          name="INFORMED CLIENT OF BENEFIT AMOUNT AND WHEN BENEFITS WILL BE AVAILABLE FOR USE"
        >
          <Checkbox value="INFORMED CLIENT OF BENEFIT AMOUNT AND WHEN BENEFITS WILL BE AVAILABLE FOR USE">
            INFORMED CLIENT OF BENEFIT AMOUNT AND WHEN BENEFITS WILL BE
            AVAILABLE FOR USE
          </Checkbox>
        </Form.Item>
      </Row>
    </Form>
  );
});
export default RUNEDBC;
